import questionsSolution from "../data/questionsSolution";
import { mainInput } from "../../index"
import displaySantaTalk from "./displaySantaTalk";
import { letters } from "../../index";

let questionCounter = 1;
function checkResult(){
  if ( mainInput.value.toLowerCase() === questionsSolution[questionCounter-1].solution ) {
    if (questionCounter<8){
      displaySantaTalk();
      questionCounter += 1;
    } else {
      displaySantaTalk();
      questionCounter += 1;
      letters.forEach( item => {
        item.style.display= 'block';
      })
    }
  }
}

function increaseCounter(){ questionCounter += 1 };

export default checkResult;
export { questionCounter, increaseCounter };